<template>
  <router-link 
    :to="to" 
    class="link" 
    :class="{ active: isActive }"
    @click="closeMobileOnNav"
  >
    <span class="link-content">
      <span class="icon-left">
        <font-awesome-icon :icon="['fa', icon]" />
      </span>
      <span class="link-label"><slot /></span>
    </span>
  </router-link>
</template>

<script>
import { computed } from 'vue'
import { mobileOpen } from '@/components/sidebar/state'
import router from '../../../router/index.js';


export default {
    props: {
        to: { type: String, required: true },
        icon: { type: String, required: true },
    },
    setup(props) {
        const isActive = computed(() => router.currentRoute.value.path === props.to)
        return { isActive, mobileOpen }
    },
    methods: {
        closeMobileOnNav() {
            if (window.innerWidth <= 599) mobileOpen.value = false;
        }
    }
}
</script>

<style scoped>

.link {
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    position: relative;
    font-weight: 500;
    letter-spacing: 0.3px;
    user-select: none;

    margin: 3px 0;
    padding: 0.75em 0.5em;
    border-radius: 8px;
    height: auto;

    color: rgba(255, 255, 255, 0.95);
    text-decoration: none;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.link.active {
    background-color: var(--sidebar-item-active);
    color: #ffffff;
    border: 1.5px solid rgba(255, 255, 255, 0.35);
    box-shadow: inset 3px 0 0 #7c9efc;
}

.link:hover {
    background-color: var(--sidebar-item-hover);
    color: #ffffff;
}

.link .icon {
    flex-shrink: 0;
    width: 25px;
    margin-right:10px;
}

.link-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.icon-left {
    flex-shrink: 0;
    font-size: 22px;
    margin-right: 0;
    margin-bottom: var(--space-1);
}

.link-label {
    font-size: var(--font-size-sm);
    line-height: var(--line-height-tight);
    text-align: center;
}



</style>
